export default "__VITE_ASSET__qAvjKD7L__"